module.exports = __webpack_public_path__ + "img/logo.941a6b9a.png";